import { render } from "./ForgotPassword.vue?vue&type=template&id=1895a647&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=1895a647&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/MASNAT/mi-stock-masnat-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1895a647"]])

export default __exports__